// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"690":"82b3004f","733":"82b3004f","1498":"82b3004f","9045":"796ffa80"}[chunkId] + ".chunk.css";
};